;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  // scripts for community page and modules found on community pages
  eah.warrantyForm = (function () {
    const initialize = function () {
      console.log('warranty form init')
      const $form = $('.warranty-form__form')
      if ($form.length) {
        console.log('form', $form)
        $('.warranty-form__button').click(function (e) {
          const $el = $(e.target)
          if ($el.attr('href') === '#') {
            e.preventDefault()
            $form.slideToggle()
          }
        })

        $(window).on('load', function () {
          if (window.location.hash && window.location.hash === '#openform') {
            $form.slideDown()
          }
        })
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.warrantyForm.initialize()
  })
}(jQuery, window))
